module.exports = __webpack_public_path__ + "static/media/student-snapshort2-comment.7b698440.png";